package com.volkswagen.vocs.grip.vocstis

import kotlin.String
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
public enum class WeightUom {
  @SerialName(value = "kg")
  Kg,
  ;

  override fun toString(): String = serializer().descriptor.getElementName(ordinal)
}
